import { resolveUploadAssetUrl } from './resolveUploadAssetUrl';

/**
 * 将笔记中的图片上传到服务器，返回可在页面中直接使用的 img src（走 /api 代理）。
 * 避免 Quill 默认把图片以 base64 写入 notes 导致保存失败或侧栏撑破布局。
 */
export async function uploadLiteratureNoteImage(file: File): Promise<string> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch('/api/upload', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd
  });
  const data = (await res.json().catch(() => ({}))) as { url?: string; error?: string; message?: string };
  if (!res.ok) {
    throw new Error(data.error || data.message || `上传失败（HTTP ${res.status}）`);
  }
  const raw = data.url;
  if (!raw || typeof raw !== 'string') {
    throw new Error('上传响应无效');
  }
  return resolveUploadAssetUrl(raw) || raw;
}
